// extracted by mini-css-extract-plugin
module.exports = {"container":"StructureListPage_container__1lvHn","actions":"StructureListPage_actions__1n0La","search":"StructureListPage_search__L_wfD","list":"StructureListPage_list__312nn"};